'use strict';

import raven from 'raven';
import angular from 'angular';
import FormController from 'app/controllers/form';
import AddPendingSpendingController from './add-pendingspending.controller';
import AddPendingSpendingTpl from './add-pendingspending.html';
import AddDepositController from './add-deposit.controller';
import AddDepositTpl from './add-deposit.html';
import Config from 'config';
import Promise from 'bluebird';

class VoucherController extends FormController {
    /* @ngInject */
    constructor(
        VouchersService,
        WorkersService,
        PendingSpendingsService,
        EmployeesService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location,
        $window,
        LoopBackAuth
    ) {
        let voucher = $scope.$parent.$resolve.voucher;
        super(
            voucher,
            'Vale',
            VouchersService,
            null,
            'vouchers'
        );
        this.user = $scope.$parent.$resolve.user;
        this.registries = $scope.$parent.$resolve.registries;

        Object.assign(this, {
            VouchersService,
            WorkersService,
            PendingSpendingsService,
            EmployeesService,
            $scope,
            $mdDialog,
            $mdToast,
            $state,
            $location,
            $window,
            LoopBackAuth
        });

        if (this.model.id) {
            this.pendingSpendings = this.model.pendingSpendings;
            this.createdByUser = this.model.createdByUser;
            this.updatedByUser = this.model.updatedByUser;
        } else {
            this.model.cashAmount = 0;
            this.model.metadata = {
                deposits: []
            };
            this.model.pendingAmount = 0;
            this.pendingSpendings = [];

            if (this.user.isAdmin) {
                // is admin
                this.canChangeEmployee = true;
            } else if (this.user.employee) {
                // non admin: fixed employee
                this.employee = this.user.employee;
                this.model.employee = this.user.employee;
            }
        }

        this.worker = this.model.worker;
        this.employee = this.model.employee;
        this.assignedEmployee = this.model.assignedEmployee;
        this.removedPendingSpendings = [];
    }

    isOwner() {
        return this.user.id == this.model.createdBy;
    }

    savePendingSpendings() {
        //this.neverEditable = true;
        let addedP = Promise.each(this.pendingSpendings, ps => {
            if (!ps.dstVoucherId) {
                return this.PendingSpendingsService.addToVoucher({
                    voucherId: this.model.id,
                    id: ps.id
                }).then(res => {
                    Object.assign(ps, res.pendingSpending);
                });
            }
        });

        let removedP = Promise.each(this.removedPendingSpendings, ps => {
            if (ps.dstVoucherId) {
                return this.PendingSpendingsService.removeFromVoucher({
                    voucherId: this.model.id,
                    id: ps.id
                }).then(res => {
                    Object.assign(ps, res.pendingSpending);
                });
            }
        });

        this.removedPendingSpendings = [];
        return Promise.all([addedP, removedP]);
    }

    $onInit() {
        super.$onInit();

        if (this.model.id) {
            this.cashReturns = this.$scope.$parent.$resolve.cashReturns;
        }

        this.isVoidable =
            !this.model.deletedAt
            && this.model.spendingsAmount == 0
            && !this.model.operativeSpendings.some(os => os.associatedAt)
            && (this.isOwner() || this.user.isAdmin);

        this.editable = this.isOwner() || this.user.isAdmin;
    }

    save() {
        if (this.form.$valid) {
            this.showSpin = true;
            if (!this.model.id) {
                this.VouchersService.createNew({
                    cashAmount: this.model.cashAmount,
                    comments: this.model.comments,
                    employeeId: this.employee && this.employee.id,
                    assignedEmployeeId: this.assignedEmployee.id,
                    deposits: this.model.metadata.deposits,
                    date: this.model.date
                }).then((res) => {
                    Object.assign(this.model, res.voucher);
                    this.updateTotal();
                    return this.savePendingSpendings();
                }).then(() => {
                    this.showSpin = false;
                    this.editable = true;
                    this.editing = false;
                    this.updateLocation();
                });
            } else {
                this.VouchersService.save(this.model).then((voucher) => {
                    Object.assign(this.model, voucher);
                    this.updateTotal();
                    return this.savePendingSpendings();
                }).then(() => {
                    this.showSpin = false;
                    this.editable = true;
                    this.editing = false;
                });
            }
        } else {
            console.debug(this.form);
        }
    }

    void(ev) {
        var confirm = this.$mdDialog.prompt()
            .title('Anulación de Vale')
            .textContent('Ingrese el motivo')
            .placeholder('Motivo de anulación')
            .ariaLabel('Motivo de anulación')
            .required(true)
            .targetEvent(ev)
            .ok('Anular el vale')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.showVoidSpin = true;
            this.VouchersService.void({
                id: this.model.id,
                reason: result
            }).then(() => {
                this.showVoidSpin = false;
                this.model.deletionReason = result;
                this.model.deletedAt = new Date();
            }, err => {
                console.error(err);
                this.simpleError();
            });
        });
    }

    queryWorkerSearch() {
        return this.WorkersService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchWorkerText}/i`
                    }
                }
            }
        });
    }

    selectedWorkerChange(worker) {
        if (worker) {
            this.model.worker = worker;
            this.worker = worker;
            this.checkForDupe();
        }
    }

    onDateChange() {
        this.checkForDupe();
    }

    checkForDupe() {
        if (this.worker && this.model.date) {
            this.VouchersService.findOne({
                filter: {
                    where: {
                        workerId: this.worker.id,
                        date: this.model.date
                    }
                }
            }).then(dupe => {
                return this.$mdDialog.show(
                    this.$mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Posible Vale duplicado')
                        .textContent(`Existe otro Vale (#${dupe.id}) \
para el mismo \
gestor y la misma fecha asignada`)
                        .ok('Aceptar')
                );
            }).catch(err => {
                // not found
            });
        }
    }

    updateTotal() {
        let pendingAmount = this.pendingSpendings
            .reduce((sum, ps) => sum + ps.amount, 0);
        let depositAmount = this.model.metadata.deposits
            .reduce((sum, d) => sum + d.amount, 0);
        this.model.amount = (this.model.cashAmount || 0)
            + (depositAmount || 0)
            + (pendingAmount || 0);
    }

    addPendingSpending(ev) {
        let where = {
            dstVoucherId: null
        };
        if (this.pendingSpendings.length) {
            where.and = this.pendingSpendings.map(ps => {
                return {
                    id: {
                        neq: ps.id
                    }
                };
            });
        }
        let pSpendingsPromise = this.PendingSpendingsService.find({
            filter: {
                where: where,
                include: ['registry'],
                order: 'createdAt ASC'
            }
        });
        this.$mdDialog.show({
            controller: AddPendingSpendingController,
            template: AddPendingSpendingTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen,
            locals: {
                pSpendingsPromise: pSpendingsPromise
            }
        }).then(data => {
            let index = this.pendingSpendings.findIndex(
                ps => ps.id == data.pSpending.id
            );
            if (index == -1) {
                this.pendingSpendings.push(data.pSpending);
            }

            let removedIndex = this.removedPendingSpendings.findIndex(
                ps => ps.id == data.pSpending.id
            );
            if (removedIndex > -1) {
                this.removedPendingSpendings.splice(removedIndex, 1);
            }

            this.updateTotal();
        }, err => {
            // dialog cancelled
        }).then(() => {

        }, err => {
            raven.captureException(err);
            console.error(err);
            this.simpleError();
        });
    }

    removePendingSpending(pSpending) {
        let index = this.pendingSpendings.findIndex(ps => ps.id == pSpending.id);
        if (index > -1) {
            this.pendingSpendings.splice(index, 1);
        }
        let removedIndex = this.removedPendingSpendings.findIndex(
            ps => ps.id == pSpending.id
        );
        if (removedIndex == -1) {
            this.removedPendingSpendings.push(pSpending);
        }

        this.updateTotal();
    }

    pdf() {
        let url = `${Config.publicUrl}/api/Vouchers/pdf?id=${this.model.id}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
        this.$window.open(url);
    }

    newPdf() {
        let url = `${Config.publicUrl}/api/Vouchers/newPdf?id=${this.model.id}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
        this.$window.open(url);
    }

    addDeposit(ev) {
        this.$mdDialog.show({
            controller: AddDepositController,
            template: AddDepositTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen,
            locals: {
                registries: this.registries
            }
        }).then(data => {
            this.model.metadata.deposits.push(data);
            this.updateTotal();
        }, err => {
            // dialog cancelled
        }).then(() => {

        }, err => {
            raven.captureException(err);
            console.error(err);
            this.simpleError();
        });
    }

    removeDeposit(deposit) {
        let index = this.model.metadata.deposits.findIndex(
            d => d.amount == deposit.amount
                && d.comments == deposit.comments
        );
        if (index > -1) {
            this.model.metadata.deposits.splice(index, 1);
        }
        this.updateTotal();
    }

    queryEmployeeSearch(text) {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${text}/i`
                    }
                }
            }
        });
    }

    selectedEmployeeChange(employee) {
        if (employee) {
            this.model.employee = employee;
            this.employee = employee;
        }
    }

    selectedAssignedEmployeeChange(employee) {
        if (employee) {
            this.model.assignedEmployee = employee;
            this.assignedEmployee = employee;
        }
    }
}

export default VoucherController;
